module.exports = __webpack_public_path__ + "img/gz.411f7056.svg";